"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addNestedRepliesToParent = addNestedRepliesToParent;
exports.findParentReply = findParentReply;
exports.getCurrentPageFromURL = getCurrentPageFromURL;
exports.prependNestedRepliesToParent = prependNestedRepliesToParent;
exports.updatePaginationSEOLinks = updatePaginationSEOLinks;
exports.updateURLForPage = updateURLForPage;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _urlGenerator = require("@insided/deprecated-preact-components/utils/urlGenerator");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Update URL for pagination
 */
function updateURLForPage(newPage) {
  if (typeof window === 'undefined' || !newPage) return;
  var newURL = (0, _urlGenerator.generateNewUrl)(newPage); // Update URL without page refresh

  window.history.pushState(null, '', newURL);
}
/**
 * Add SEO-friendly pagination link tags to document head
 * TODO - The logic will be updated to use from server side
 */


function updatePaginationSEOLinks(currentPage, hasNext, hasPrevious) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return; // Remove existing pagination link tags

  var existingLinks = document.querySelectorAll('link[rel="next"], link[rel="prev"]');
  existingLinks.forEach(function (link) {
    return link.remove();
  });

  if (hasNext) {
    var nextPage = currentPage + 1;
    var nextURL = (0, _urlGenerator.generateNewUrl)(nextPage);
    var nextLink = document.createElement('link');
    nextLink.rel = 'next';
    nextLink.href = nextURL;
    document.head.appendChild(nextLink);
  }

  if (hasPrevious && currentPage > 1) {
    var prevPage = currentPage - 1;
    var prevURL = (0, _urlGenerator.generateNewUrl)(prevPage);
    var prevLink = document.createElement('link');
    prevLink.rel = 'prev';
    prevLink.href = prevURL;
    document.head.appendChild(prevLink);
  }
}
/**
 * Get current page number from URL
 * TODO - The logic will be updated to use from server side
 */


function getCurrentPageFromURL() {
  if (typeof window === 'undefined') return 1;
  var regex = /\/index(\d+)\.html/;
  var match = regex.exec(window.location.pathname);
  return match ? parseInt(match[1], 10) : 1;
}

function addNestedRepliesToParent(replies, parentId, newReplies, newMetadata) {
  // @ts-expect-error // Not ideal bit I'll check this one later
  return replies.map(function (reply) {
    var _reply$children2;

    if (reply.id === parentId) {
      var _reply$children;

      return _objectSpread(_objectSpread({}, reply), {}, {
        children: _objectSpread(_objectSpread({}, reply.children), {}, {
          result: [].concat((0, _toConsumableArray2.default)(((_reply$children = reply.children) === null || _reply$children === void 0 ? void 0 : _reply$children.result) || []), (0, _toConsumableArray2.default)(newReplies)),
          metadata: newMetadata ? _objectSpread(_objectSpread({}, newMetadata), {}, {
            offset: reply.children.metadata.offset,
            depthLevel: reply.children.metadata.depthLevel,
            hasPrevious: reply.children.metadata.hasPrevious
          }) : reply.children.metadata
        })
      });
    }

    if ((_reply$children2 = reply.children) !== null && _reply$children2 !== void 0 && _reply$children2.result) {
      return _objectSpread(_objectSpread({}, reply), {}, {
        children: _objectSpread(_objectSpread({}, reply.children), {}, {
          result: addNestedRepliesToParent(reply.children.result, parentId, newReplies, newMetadata)
        })
      });
    }

    return reply;
  });
}
/**
 * Find a parent reply by ID in the replies tree
 */


function findParentReply(replies, parentId) {
  var _iterator = _createForOfIteratorHelper(replies),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _reply$children3;

      var reply = _step.value;
      if (reply.id === parentId) return reply;

      if ((_reply$children3 = reply.children) !== null && _reply$children3 !== void 0 && _reply$children3.result) {
        var found = findParentReply(reply.children.result, parentId);
        if (found) return found;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return null;
}
/**
 * Prepend nested replies to the beginning of a parent's children
 */


function prependNestedRepliesToParent(replies, parentId, newReplies, previousOffset) {
  var updatedReplies = replies.map(function (reply) {
    var _reply$children4;

    if (reply.id === parentId && reply.children) {
      return _objectSpread(_objectSpread({}, reply), {}, {
        children: _objectSpread(_objectSpread({}, reply.children), {}, {
          result: [].concat((0, _toConsumableArray2.default)(newReplies), (0, _toConsumableArray2.default)(reply.children.result)),
          metadata: _objectSpread(_objectSpread({}, reply.children.metadata), {}, {
            offset: previousOffset,
            hasPrevious: previousOffset > 0
          })
        })
      });
    }

    if ((_reply$children4 = reply.children) !== null && _reply$children4 !== void 0 && _reply$children4.result) {
      return _objectSpread(_objectSpread({}, reply), {}, {
        children: _objectSpread(_objectSpread({}, reply.children), {}, {
          result: prependNestedRepliesToParent(reply.children.result, parentId, newReplies, previousOffset)
        })
      });
    }

    return reply;
  });
  return updatedReplies;
}